import React from 'react';
import { connect } from "react-redux";
import { AppActions, IState, NewMetaItemValues, PaDocument} from '../../types/types'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { ThunkDispatch } from 'redux-thunk';
import { setTransferToProtekniskVisible, TransferDocuments } from '../../actions/folderViewActions';
import { docPathValue } from '../../types/enums';


interface RevisionListProps {
        docPath: docPathValue;
        documentList: PaDocument[];
        saveInProgres: boolean;
        newMetaItemValues: NewMetaItemValues[];
        onReload: (requestId:string) => void;
        onSave: (docPath:docPathValue)=> void;
      }

const DocumentList = (props:RevisionListProps) => {

  const params = new URLSearchParams(window.location.search);
  let requestIdInURL="";
  if(params.has('requestId')) requestIdInURL = params.get('requestId')!;
  //if(params.has('historisk')) historisk = params.get('historisk')!;
  let buttonName="Copy from FDV to TOS";
  if(props.docPath === docPathValue.historisk) buttonName="Copy from historisk to FDV";
  if(props.docPath === docPathValue.proteknisk) buttonName="Copy from Proteknisk to TOS";
  return <div>
             <TableContainer component={Paper}>
                <Table size="small" padding="none">
                  <TableRow>
                    <TableCell className="HeaderStatusDrop">
                    </TableCell>
                   <TableCell>
                  </TableCell>
                   <TableCell width="420" className="AlignBottom">
                      <Button className="MuiButtonMargin" size="small" variant="contained" disabled={props.saveInProgres} onClick={()=>props.onReload(requestIdInURL)}>Reload list</Button>
                      <Button className="MuiButtonMargin" size="small" variant="contained" onClick={()=>props.onSave(props.docPath)}
                        disabled={props.saveInProgres}
                        >{buttonName}</Button>
                    </TableCell>
                  </TableRow>
                  <TableRow className="EmptyRow">
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  </TableRow>
                </Table>
                <Table size="small" padding="none" id="DocumentList" className="DocumentList">
                  <TableHead>
                    <TableRow className="MuiTblHeaderRow">
                      <TableCell width="150">Document ID</TableCell>
                      <TableCell>Title</TableCell>
                      <TableCell width="50">Rev.</TableCell>
                      <TableCell width="100">Status</TableCell>
                      <TableCell className="resultCell"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {props.documentList
                      .sort((a,b) => a.DocId>b.DocId ? 1 : -1)
                      .map(row => {
                        return <TableRow key={row.DocId}>                        
                                  <TableCell component="th" scope="row">{row.DocId}</TableCell>
                                  <TableCell>{row.MetaItems.filter(x=> x.Name==="TITLE").length>0 ? row.MetaItems.filter(x=> x.Name==="TITLE")[0].Value :""}</TableCell>
                                  <TableCell>{row.CurrentRevision.RevisionCode}</TableCell>
                                  <TableCell>{row.CurrentRevision.Status}</TableCell>                        
                                  <TableCell>
                                                  {props.newMetaItemValues.filter(x=>
                                                          x.DocumentID === row.DocId
                                                          && x.SaveResult !== undefined && x.SaveResult !== "" 
                                                    ).length > 0
                                                    ? props.newMetaItemValues.filter(x=>
                                                        x.DocumentID === row.DocId
                                                        && x.SaveResult !== undefined && x.SaveResult !== "" 
                                                      )[0].SaveResult 
                                                    : ""
                                                  }  
                                  </TableCell>
                      </TableRow>
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
      </div>
      
}

const mapStateToPropsDocumentList = (state:IState) => { 
  return {
   saveInProgres:state.uiState.TRANSFER_DOCUMENTS_IsLoading,
   documentList: state.uiItems.documentList,
   newMetaItemValues: state.uiItems.newMetaItemValues,
}}
const mapDispatchToPropsDocumentList = (dispatch:ThunkDispatch<IState,undefined,AppActions>)  => ( {
  onReload: (requestId:string) => dispatch(setTransferToProtekniskVisible(requestId)),
  onSave: (docPath:docPathValue) => dispatch(TransferDocuments(docPath)),
})

export default connect(mapStateToPropsDocumentList,mapDispatchToPropsDocumentList)(DocumentList) 

  